import { useMutation } from "@tanstack/react-query";
import { ListCommanWay } from "API/commonApi";
import { Img } from "components/Img";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";

export type Props = Partial<{
  awbData: any;
  setAwbData: (data: any) => void;
  className: string;
  isLabelOpen: boolean;
  setIsLabelOpen: (isOpen: boolean) => void;
}>;

export const AwbLabel: React.FC<Props> = ({ awbData = {}, setAwbData, className = "", setIsLabelOpen, isLabelOpen }) => {
  console.log("AwbLabel", awbData);
  const [cityCodes, setCityCodes] = useState<any>("");

  const { mutate: cityCodesMutate }: any = useMutation((names) => ListCommanWay("/admin/city/list", { city_name: names }, {}), {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        let obj = {};
        try {
          obj[data.data.data[0].city_name] = data.data.data[0].cityCode;
          obj[data.data.data[1].city_name] = data.data.data[1].cityCode;
          setCityCodes(obj);
        } catch (ignored) {
          setCityCodes(obj);
        }
      }
    },
    onError: (data: any) => {},
  });

  useEffect(() => {
    if (awbData?.awb_no) {
      cityCodesMutate([awbData?.destination || "", awbData?._assign_to_booking?.shipper_city || ""]);
    }
  }, [awbData?.awb_no]);
  const handlePrint = () => {
    let w = window.open();
    w.document.write(
      `<style>@page {size: 4in 4in;margin: 0.08in 0.08in 0.08in 0.16in;}p{margin:0}</style><body style="margin: 0">${
        document.getElementById("mbag-slip-outer").innerHTML
      }</body>`
    );
    w.print();
    w.close();
  };

  const downloadSlipPopup = async () => {
    document.body.classList.add("inline-all-img");
    try {
      const input1 = document.getElementById("pdf-content1");
      const canvas = await html2canvas(input1);
      const imgData = canvas.toDataURL("image/png");
      document.body.classList.remove("inline-all-img");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "in",
        format: [4 * 1.25, 4 * 1.25],
      });
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save((awbData?.awb_no || "AWB_Slip") + ".pdf");
    } catch {
      document.body.classList.remove("inline-all-img");
    }
  };

  const getDimWeight = (product_code, ll, bb, hh) => {
    if (!ll || !bb || !hh) return 0;

    ll = Number(ll);
    bb = Number(bb);
    hh = Number(hh);
    let dWeight = (ll * bb * hh) / (product_code == "X" ? 2700 : 5000);
    return dWeight + " Kg";
  };

  const AwbLabel = ({ scale = 1, awbData, index }) => {
    const s = (val) => `${val * scale}px`;

    return (
      <div
        id="pdf-content1"
        style={{
          width: s(384),
          height: s(384),
          border: `${s(2)} solid #000`,
          boxSizing: "border-box",
          padding: s(8),
          fontFamily: "sans-serif",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {false && (
          <>
            <span style={{ fontSize: s(34), position: "absolute", left: 0, top: 0, lineHeight: 0.9 }}>⚀</span>
            <span style={{ fontSize: s(34), position: "absolute", left: 0, bottom: 0, lineHeight: 0.9 }}>⚁</span>
            <span style={{ fontSize: s(34), position: "absolute", right: 0, top: 0, lineHeight: 0.9 }}>⚂</span>
            <span style={{ fontSize: s(34), position: "absolute", right: 0, bottom: 0, lineHeight: 0.9 }}>⚃</span>
          </>
        )}

        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: s(4),
          }}
        >
          <div>
            Book Date:{" "}
            {awbData?._assign_to_booking?.date.includes("T")
              ? moment(awbData?._assign_to_booking?.date).format("DD-MM-YYYY")
              : moment(awbData?._assign_to_booking?.date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: s(10) }}>
            <span style={{ fontSize: s(36), fontWeight: "bold", lineHeight: 1, fontFamily: "monospace" }}>
              {cityCodes[awbData?._assign_to_booking?.shipper_city] || ""}
            </span>
            <span style={{ fontSize: s(22), fontWeight: "bold", lineHeight: 1, fontFamily: "monospace" }}>⟶</span>
            <span style={{ fontSize: s(36), fontWeight: "bold", lineHeight: 1, fontFamily: "monospace" }}>
              {cityCodes[awbData?.destination]}
            </span>
          </div>
        </div>

        {/* Sub Labels */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: s(12),
            marginBottom: s(10),
            padding: `${s(5)} 0`,
            borderTop: "1px solid black",
            borderBottom: "1px solid black",
            lineHeight: 1,
          }}
        >
          <div>
            <p style={{ marginBottom: s(5) }}>
              <strong>{awbData?.consignee}</strong>
            </p>

            <span style={{ fontSize: s(16) }}>
              {awbData?.address} | <b style={{ fontSize: s(18) }}>{awbData?.pincode}</b>
            </span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: s(14),
            marginBottom: s(10),
          }}
        >
          {/* Weight and Mbag */}
          <div
            style={{
              fontSize: s(18),
              marginRight: s(5),
            }}
          >
            <div style={{ fontSize: s(14), lineHeight: 1.5 }}>
              <p>
                Commercial Value: <b>{awbData?.commercialValue || "N/A"}</b>
              </p>
            </div>
            <div style={{ fontSize: s(14), lineHeight: 1.5 }}>
              <p>
                10:30: <b>{awbData?.is10_30 ? "Y" : "N"}</b>
              </p>
              <p>
                Holiday: <b>{awbData?.holiday ? "Y" : "N"}</b>
              </p>
              <p>
                Type: <b>{awbData?.dox_or_non_dox ? "Dox" : "Non Dox"}</b>
              </p>
            </div>
          </div>

          {/* QR Code Box */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: s(4),
            }}
          >
            {!awbData?.isPickup && (
              <b style={{ fontSize: s(18), lineHeight: 1.5 }}>
                <u>Ref#: {awbData?._assign_to_booking?.pickup_code || "N/A"}</u>
              </b>
            )}
            <QRCode value={awbData?.awb_no || ""} size={scale * 100} level="M" />
            <span style={{ fontSize: s(24), lineHeight: 1, marginTop: s(5) }}>
              <b>{awbData?.awb_no}</b>
            </span>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
          }}
        >
          <div style={{ fontWeight: "bold" }}>
            <Img src={"/logo.jpg"} style={{ height: s(50) }} />
          </div>
          <div>
            {!awbData?.isPickup && (
              <div style={{ fontSize: s(30), lineHeight: 1, textAlign: "right", marginTop: s(2) }}>
                MPS:{" "}
                <strong>
                  {index + 1}/{awbData?.innerItemsNos || 1}
                </strong>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-black-900 bg-opacity-50 flex items-center justify-center font-inter" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-2xl shadow-lg  p-6 relative">
        {/* Close Button */}
        <button
          className="absolute top-6 right-6 text-gray-600 hover:text-black bg-gray-300 px-2 text-lg font-bold rounded-md"
          onClick={() => {
            setIsLabelOpen(false);
          }}
        >
          &times;
        </button>

        {/* Title */}
        <h2 className="text-xl font-bold mb-4">Airway Bill Slip</h2>

        <div className="my-4 overflow-auto max-h-[80vh]" id="mbag-slip-outer">
          {Array.from({ length: awbData?.innerItemsNos || 1 }).map((_, index) => (
            <AwbLabel key={index} scale={1.25} awbData={awbData} index={index} />
          ))}
        </div>
        {/* Submit Button */}
        <div className="flex gap-4">
          <button onClick={downloadSlipPopup} type="button" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
            Download
          </button>
          <button onClick={handlePrint} type="button" className="w-full bg-green-600 text-white py-2 rounded hover:bg-blue-700">
            Print
          </button>
        </div>
      </div>
    </div>
  );
};
